import React, { memo, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { navigationStep } from "../../redux/slices/navigation";
import { addTypeCard } from "../../redux/slices/cardType";
import {
  CardTypeQrArray,
  getCardTypeQr,
} from "../../page/FirstScreen/cardTypeQr";
import useIsNoIframe from "../../hooks/useIsNoIframe";
import { isNoEditRoute } from "../../hooks/helpers";
import { Container } from "react-bootstrap";
import Progress from "./progress";
import Breadcrumbs from "../breadcrumbs";
import classNames from "classnames";
import { webView } from "../../variables/webView";
import useCurrentLocation from "../../hooks/useCurrentLocation";

function Navigation() {
  const lang = useSelector((state) => state.changeLang.language.breadcrumbs);
  const type = useSelector((state) => state.typeCard.type);
  const cartTypeLang = useSelector(
    (state) => state.changeLang.language.cartType
  );

  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { pathname } = useLocation();
  const { isNoIframe } = useIsNoIframe();
  const { isTemplateParam } = useCurrentLocation();

  const cardTypeQr = useMemo(() => {
    return getCardTypeQr(cartTypeLang);
  }, [cartTypeLang]);

  useEffect(() => {
    if (pathname === "/") {
      dispatch(navigationStep(1));
    }
    if (type && pathname === `/${type}`) {
      dispatch(navigationStep(2));
    }
    if (pathname === `/qr`) {
      dispatch(navigationStep(3));
    }
  }, [pathname]);

  const breadcrumbs = useMemo(() => {
    return [
      {
        id: 0,
        name: "ME-QR",
        pathname: "/",
        isActive: false,
      },
      {
        id: 1,
        name: lang.type,
        pathname: "/",
        isActive: pathname === `/`,
      },
      ...(pathname !== `/` && pathname !== `/qr`
        ? [
            {
              id: 2,
              name: type
                ? `${cardTypeQr.find((item) => item.nav === type).title}`
                : "",
              pathname: `/${type}`,
              isActive: pathname !== `/qr`,
            },
          ]
        : []),
      ...(pathname === `/qr`
        ? [
            {
              id: 3,
              name: lang.customize,
              pathname: "/qr",
              isActive: pathname === `/qr`,
            },
          ]
        : []),
    ];
  }, [pathname, type]);

  useEffect(() => {
    if (
      !!CardTypeQrArray.filter(
        (i) => pathname.match(/^\/([^\/]*).*$/)[1] === i.nav
      )[0]?.nav
    ) {
      dispatch(navigationStep(2));
      dispatch(
        addTypeCard(
          CardTypeQrArray.filter(
            (i) => pathname.match(/^\/([^\/]*).*$/)[1] === i.nav
          )[0]?.nav
        )
      );
    }
  }, []);

  function handlerBtnNav(id) {
    if (id === 0) {
      window.location.href = "/";
    } else if (id === 1) {
      dispatch(navigationStep(1));
      navigate("/");
    } else if (id === 2 && type.length) {
      dispatch(navigationStep(2));
      navigate(`/${type}`);
    } else {
      dispatch(navigationStep(1));
      navigate("/");
    }
  }

  return (
    isNoIframe &&
    isNoEditRoute && (
      <>
        <Container>
          {!webView && !isTemplateParam ? (
            <div className={classNames("pt-3")} style={{ marginBottom: -15 }}>
              <Breadcrumbs breadcrumbs={breadcrumbs} />
            </div>
          ) : null}
          <Progress handlerBtnNav={handlerBtnNav} />
        </Container>
      </>
    )
  );
}

export default memo(Navigation);
